import { deleteRequest, get, post, publicPost, put } from "../../helpers/apihelpers";

export const CreateCurrentLinkModelService=async(data)=>{
    try {
        const result = await post(`api/admin/current_link_model/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateCurrentLinkModelService=async(data,id)=>{
    try {
        const result = await put(`api/admin/current_link_model/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetCurrentLinkModelService=async()=>{
    try {
        const result = await get(`api/admin/current_link_model/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteCurrentLinkModelService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/current_link_model/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

